import { render, staticRenderFns } from "./filter-list.vue?vue&type=template&id=1d2237b2"
import script from "./filter-list.vue?vue&type=script&lang=js"
export * from "./filter-list.vue?vue&type=script&lang=js"
import style0 from "./filter-list.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports